<template>
	<div class="additional-messages">
		<div class="blue-title">账户附加信息</div>
		<el-row :gutter="40">
			<el-col :span="14">
				<div class="leftDiv colDiv">
					<div class="text">广告 · http://www.example.com</div>
					<div class="title">
						标题一 <el-divider direction="vertical"></el-divider>标题二
						<el-divider direction="vertical"></el-divider>标题三
					</div>
					<div class="text">说明一 说明二 说明三 说明四</div>
					<div class="text">{{ calloutText }}</div>
					<div class="text">{{ structuredSnippetValues }}</div>
					<div class="linkurl">
						<div
							v-for="(item, index) in siteLinks"
							:key="index"
							@click="link(item.linkUrl)"
							
							>
							<div class="space"> {{ item.linkText }} </div>
							<div class="explain"> {{ item.description1 }} </div>
							<div class="explain">  {{ item.description2 }} </div></div
						>
					</div>
				</div>
			</el-col>
			<el-col :span="10">
				<div class="colDiv">
					<div v-for="(item, index) in siteLinks" :key="index" class="linkbox">
						<div class="linkName">{{ item.linkText }}</div>
						<div class="link" @click="link(item.linkUrl)">{{ item.linkUrl }}</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	props: ['adCustomerAssetVo'],
	data() {
		return {};
	},

	components: {},
	computed: {
		calloutText() {
			return this.adCustomerAssetVo && this.adCustomerAssetVo.calloutText
				? this.adCustomerAssetVo.calloutText.join('。')
				: '';
		},
		structuredSnippetValues() {
			return this.adCustomerAssetVo && this.adCustomerAssetVo.structuredSnippetValues
				? this.adCustomerAssetVo.structuredSnippetValues.join(',')
				: '';
		},
		siteLinks() {
			return this.adCustomerAssetVo && this.adCustomerAssetVo.siteLinks
				? this.adCustomerAssetVo.siteLinks
				: '';
		},
	},

	methods: {
		link(path) {
			window.open(path);
		},
	},
};
</script>

<style lang="scss" scoped>
.additional-messages {
	padding: 30px;
	.colDiv {
		background: #ffffff;
		box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.1);
		border-radius: 2px;
		padding: 20px;
		font-size: 14px;
	}
	.leftDiv {
		.title {
			color: #1a0dab;
			font-size: 18px;
			font-weight: 500;
			margin-bottom: 5px;
			::v-deep .el-divider {
				background: #1a0dab;
				font-size: 18px;
				font-weight: 500;
			}
		}
		.text {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			padding-bottom: 5px;
			word-wrap: break-word;
		}
	}
	.blue-title {
		border-left: 5px #3da1ff solid;
		padding: 0px 10px;
		font-size: 16px;
		font-weight: 500;
		margin-bottom: 20px;
	}
	.linkbox {
		margin-bottom: 10px;
		display: flex;
		justify-items: baseline;
		/* justify-content:space-around */
	}
	.link {
		flex:1;
		color: #1a0dab;
		cursor: pointer;
		text-align: left;
		word-break: break-all;
	}
	.linkurl {
		color: #1a0dab;
		cursor: pointer;
		margin-top: 5px;
		/* display: inline-block;
		text-align: left;
		padding-right: 10px; */
		font-size: 14px;
		display: grid;
		grid-template-columns: repeat(2, 44%);
		gap: 15px 20px;
		.explain {
			color: #999999;
		}
		.space{
			margin-bottom: 5px;
		}
	}
	.linkName {
		margin-right: 30px;
		width: 40%;
	}
}
</style>
